import { ForecastTimelineFilterProperty, RequiredForecastTimelineFilterProperty } from '../entities/filter';

/**
 * フィルターのファクトリ
 */
export class FilterFactory {
  /**
   * 必須の内示遍歴フィルタを生成する
   * @param initialData - 初期データ
   */
  public static createRequiredForecastTimelineFilter = (
    initialData: ForecastTimelineFilterProperty = {
      warehouseCode: undefined,
      warehouse: undefined,
      supplierCode: undefined,
      supplierName: undefined,
      businessCode: undefined,
      businessName: undefined,
      packageAmount: undefined,
      customerCode: undefined,
      customerName: undefined,
      salesDestinationCode: undefined,
      salesDestinationName: undefined,
      staffName: undefined,
    }
  ): RequiredForecastTimelineFilterProperty => {
    return {
      // staffName: initialData.staffName ?? '',
      warehouseCode: initialData.warehouseCode ?? '',
      warehouse: initialData.warehouse ?? '',
      supplierCode: initialData.supplierCode ?? '',
      supplierName: initialData.supplierName ?? '',
      businessCode: initialData.businessCode ?? '',
      businessName: initialData.businessName ?? '',
      packageAmount: initialData.packageAmount ?? 0,
      customerCode: initialData.customerCode ?? '',
      customerName: initialData.customerName ?? '',
      salesDestinationCode: initialData.salesDestinationCode ?? '',
      salesDestinationName: initialData.salesDestinationName ?? '',
    };
  };
}
